import * as React from 'react';

export function TenantHelpBanner() {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className="mb-6 rounded-lg border border-teal-700 bg-teal-80020 px-4 py-3">
      <button
        type="button"
        className="flex w-full items-center gap-2.5 text-left"
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        <svg
          className="size-4 shrink-0 text-teal"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
          />
        </svg>
        <span className="flex-1 text-sm text-white">
          Tenants are integrators (SCC, DCC, LCC) with configuration that can differ from the general market config.
        </span>
        <span className="shrink-0 text-xs text-teal">{isExpanded ? 'Collapse ▲' : 'Learn more ▼'}</span>
      </button>

      {isExpanded && (
        <div className="mt-3 space-y-2 border-t border-teal-700 pt-3 text-sm leading-relaxed text-gray-300">
          <p>
            <strong className="text-white">What are tenants?</strong> Tenants are integration partners (e.g., SCC, DCC,
            LCC) who embed the 3D Exhibition in their own platforms.
          </p>
          <p>
            <strong className="text-white">Why separate configs?</strong> Each tenant may need different feature flags,
            configurator links, or access controls than the general market setup.
          </p>
          <p>
            <strong className="text-white">&ldquo;All Tenants&rdquo; (*):</strong> The default configuration that
            applies to every tenant without its own specific setup.
          </p>
          <p>
            <strong className="text-white">Tenant-specific:</strong> Overrides the default for one tenant. Only the
            differences need to be configured — everything else falls back to &ldquo;All Tenants.&rdquo;
          </p>
        </div>
      )}
    </div>
  );
}
